import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MatCardModule } from '@angular/material/card';

@Component({
    templateUrl: './PageNotFound.component.html',
    imports: [MatCardModule],
})
export class PageNotFoundComponent {}
